import getAuthenticatedHeaders from 'services/firebase/getAuthenticatedHeaders'

/**
 * Persists the exact order of one ingredient-tree sibling set.
 *
 * @param {Object} payload Reorder request.
 * @param {string|null} payload.parentPath Parent node path, or null for root.
 * @param {string[]} payload.orderedNodeIds Exact ordered sibling IDs.
 * @returns {Promise<Object>} Backend reorder summary.
 */
const reorderNodes = async ({ parentPath = null, orderedNodeIds }) => {
  const payload = { parentPath, orderedNodeIds }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_FUNCTIONS_API_URL}/ingredients/reorderNodes`,
      {
        method: 'PUT',
        headers: await getAuthenticatedHeaders({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(payload)
      }
    )
    const result = await response.json()

    if (!response.ok || result.success === false) {
      const error = new Error(
        result.message || `Failed to reorder nodes: ${response.statusText}`
      )
      error.code = result.code || 'UNKNOWN_ERROR'
      error.details = result.details
      error.response = {
        status: response.status,
        statusText: response.statusText,
        data: result
      }
      throw error
    }

    return result
  } catch (error) {
    console.error('reorderNodes API: Error reordering nodes', {
      error: error.message,
      code: error.code,
      details: error.details,
      payload
    })
    throw error
  }
}

export default reorderNodes
